<!--
 * @Author: yang bo
 * @Date: 2019-12-03 14:53:02
 * @LastEditors: yang bo
 * @LastEditTime: 2019-12-09 15:55:08
 * @Description:
 -->
<template>
  <div>
    <div class="header">
      <div class="nav">
        <Menu @handchange="handChange" class="menu" />
        <!--<div class="infor">
          <span class="name">{{name}}</span>
          <span class="login-out" @click="loginOut">登出</span>
        </div>-->
      </div>
      <!--<Breadcrumb :breadcrumbList="breadcrumbList" />-->
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu";
import Breadcrumb from "./Breadcrumb";
export default {
  created() {
    this.name = localStorage.getItem("account") || ""
  },
  data() {
    return {
      name: "123",
      breadcrumbList: []
    };
  },
  watch: {
    $route() {
      this.handChange();
    }
  },
  methods: {
    handChange(val) {
      this.breadcrumbList = val || [];
    },
    loginOut() {
      localStorage.removeItem("ssoUser")
      this.$router.push({ path: `/login` })
    }
  },
  components: {
    Menu,
    Breadcrumb
  }
};
</script>
<style scoped>
.menu {
  margin-bottom: 20px;
  margin-left: 10px;
}
.header {
  margin-bottom: 30px;
}
.nav {
  position: relative;
}
.infor {
  position: absolute;
  top: 10px;
  right: 10px;
}
.name {
  color: #409eff;
}
.login-out {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/include/UserContent.vue